import React, { useState, useEffect } from "react";
// import success from "../assets/success.png"; // Adjust the import path accordingly
import styles from "./LoadingCircle.module.scss"; // Import SCSS module
import success from "img/genai/checkbox.svg";
import starLoader from "img/genai/StarLoader.svg";

export const LoadingCircle = ({ loaderText }) => {
  const [completionStatus, setCompletionStatus] = useState(
    new Array(loaderText.length).fill(false) // Track completion status
  );
  const [currentTextIndex, setCurrentTextIndex] = useState(0); // Track active text

  useEffect(() => {
    if (currentTextIndex < loaderText.length) {
      setCompletionStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[currentTextIndex] = false; // Start with spinner
        return newStatus;
      });

      const timeout = setTimeout(() => {
        setCompletionStatus((prevStatus) => {
          const newStatus = [...prevStatus];
          newStatus[currentTextIndex] = true; // Mark as completed
          return newStatus;
        });
      }, 3000);

      const nextTextTimeout = setTimeout(() => {
        setCurrentTextIndex((prevIndex) => prevIndex + 1);
      }, 3000);

      return () => {
        clearTimeout(timeout);
        clearTimeout(nextTextTimeout);
      };
    }
  }, [currentTextIndex, loaderText.length]);

  return (
    <div className={styles.loadContainer}>
      <div className={styles.content}>
        {loaderText.map((text, index) => (
          <div key={index} className={styles.loaderText}>
            {index <= currentTextIndex ? (
              <>
                {!completionStatus[index] ? (
                  <>
                    <div className={styles.loaderContainer}>
                      {/* <span>
                        <img
                          src={starLoader}
                          alt="loader"
                          className={styles.strloader}
                        />
                      </span> */}
                      <div>
                        <div className={styles.loaderLine}></div>
                        <div className={styles.loaderLine}></div>
                        <div className={styles.loaderLine}></div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <img src={success} alt="Success" width={12} />
                    <span className={styles.smallText}>{text}</span>
                  </>
                )}
              </>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};


export const TimedLoadingCircle = ({ loaderText, totalDuration }) => {
  console.log(totalDuration,`tottaldr`);
  
  const [completionStatus, setCompletionStatus] = useState(
    new Array(loaderText.length).fill(false)
  );
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  // Compute per-step duration
  const stepDuration = totalDuration / loaderText.length;

  useEffect(() => {
    if (currentTextIndex < loaderText.length) {
      // Start current step with spinner
      setCompletionStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[currentTextIndex] = false;
        return newStatus;
      });

      // Mark this step as complete after stepDuration
      const timeout = setTimeout(() => {
        setCompletionStatus((prevStatus) => {
          const newStatus = [...prevStatus];
          newStatus[currentTextIndex] = true;
          return newStatus;
        });
      }, stepDuration);

      // Move to next step
      const nextTextTimeout = setTimeout(() => {
        setCurrentTextIndex((prevIndex) => prevIndex + 1);
      }, stepDuration);

      return () => {
        clearTimeout(timeout);
        clearTimeout(nextTextTimeout);
      };
    }
  }, [currentTextIndex, loaderText.length, stepDuration]);

  return (
    <div className={styles.loadContainer}>
      <div className={styles.content}>
        {loaderText.map((text, index) => (
          <div key={index} className={styles.loaderText}>
            {index <= currentTextIndex ? (
              <>
                {!completionStatus[index] ? (
                  <div className={styles.loaderContainer}>
                    <span>
                      <img
                        src={starLoader}
                        alt="loader"
                        className={styles.strloader}
                      />
                    </span>
                    <div>
                      <div className={styles.loaderLine}></div>
                      <div className={styles.loaderLine}></div>
                      <div className={styles.loaderLine}></div>
                    </div>
                  </div>
                ) : (
                  <>
                    <img src={success} alt="Success" width={20} />
                    <span className={styles.smallText}>{text}</span>
                  </>
                )}
              </>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};
